/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardGrant } from './RewardGrant';
import {
    RewardGrantFromJSON,
    RewardGrantFromJSONTyped,
    RewardGrantToJSON,
    RewardGrantToJSONTyped,
} from './RewardGrant';
import type { SubscriptionPrice } from './SubscriptionPrice';
import {
    SubscriptionPriceFromJSON,
    SubscriptionPriceFromJSONTyped,
    SubscriptionPriceToJSON,
    SubscriptionPriceToJSONTyped,
} from './SubscriptionPrice';
import type { TierEntitlement } from './TierEntitlement';
import {
    TierEntitlementFromJSON,
    TierEntitlementFromJSONTyped,
    TierEntitlementToJSON,
    TierEntitlementToJSONTyped,
} from './TierEntitlement';

/**
 * Represents a single subscription tier.
 * @export
 * @interface SubscriptionTier
 */
export interface SubscriptionTier {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionTier
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionTier
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionTier
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionTier
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionTier
     */
    description?: string;
    /**
     * Hex color for the tier's avatar ring and other tier-identity accents.
     * @type {string}
     * @memberof SubscriptionTier
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionTier
     */
    stripeProductId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionTier
     */
    isActive: boolean;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionTier
     */
    xpMultiplier: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionTier
     */
    tierLevel: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionTier
     */
    level4Access: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionTier
     */
    image?: string;
    /**
     * 
     * @type {Array<SubscriptionPrice>}
     * @memberof SubscriptionTier
     */
    pricing: Array<SubscriptionPrice>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SubscriptionTier
     */
    upgradeFromPromos?: { [key: string]: string; };
    /**
     * 
     * @type {Array<TierEntitlement>}
     * @memberof SubscriptionTier
     */
    entitlements?: Array<TierEntitlement>;
    /**
     * Catalog-item grants (reward-catalog Option B) paid alongside monthlyRewardConfigIds.
     * @type {Array<RewardGrant>}
     * @memberof SubscriptionTier
     */
    monthlyRewardGrants?: Array<RewardGrant>;
    /**
     * Catalog-item grants paid alongside onSubscribeRewardConfigIds.
     * @type {Array<RewardGrant>}
     * @memberof SubscriptionTier
     */
    onSubscribeRewardGrants?: Array<RewardGrant>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionTier
     */
    monthlyRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionTier
     */
    onSubscribeRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof SubscriptionTier
     */
    upgradeFromRewards?: { [key: string]: Array<string>; };
    /**
     * When true, no Stripe product is created. Used for Industry Pass and manual tier assignment.
     * @type {boolean}
     * @memberof SubscriptionTier
     */
    isLegacyTier?: boolean;
}

/**
 * Check if a given object implements the SubscriptionTier interface.
 */
export function instanceOfSubscriptionTier(value: object): value is SubscriptionTier {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('stripeProductId' in value) || value['stripeProductId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('xpMultiplier' in value) || value['xpMultiplier'] === undefined) return false;
    if (!('tierLevel' in value) || value['tierLevel'] === undefined) return false;
    if (!('level4Access' in value) || value['level4Access'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    return true;
}

export function SubscriptionTierFromJSON(json: any): SubscriptionTier {
    return SubscriptionTierFromJSONTyped(json, false);
}

export function SubscriptionTierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionTier {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'color': json['color'] == null ? undefined : json['color'],
        'stripeProductId': json['stripeProductId'],
        'isActive': json['isActive'],
        'xpMultiplier': json['xpMultiplier'],
        'tierLevel': json['tierLevel'],
        'level4Access': json['level4Access'],
        'image': json['image'] == null ? undefined : json['image'],
        'pricing': ((json['pricing'] as Array<any>).map(SubscriptionPriceFromJSON)),
        'upgradeFromPromos': json['upgradeFromPromos'] == null ? undefined : json['upgradeFromPromos'],
        'entitlements': json['entitlements'] == null ? undefined : ((json['entitlements'] as Array<any>).map(TierEntitlementFromJSON)),
        'monthlyRewardGrants': json['monthlyRewardGrants'] == null ? undefined : ((json['monthlyRewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'onSubscribeRewardGrants': json['onSubscribeRewardGrants'] == null ? undefined : ((json['onSubscribeRewardGrants'] as Array<any>).map(RewardGrantFromJSON)),
        'monthlyRewardConfigIds': json['monthlyRewardConfigIds'] == null ? undefined : json['monthlyRewardConfigIds'],
        'onSubscribeRewardConfigIds': json['onSubscribeRewardConfigIds'] == null ? undefined : json['onSubscribeRewardConfigIds'],
        'upgradeFromRewards': json['upgradeFromRewards'] == null ? undefined : json['upgradeFromRewards'],
        'isLegacyTier': json['isLegacyTier'] == null ? undefined : json['isLegacyTier'],
    };
}

export function SubscriptionTierToJSON(json: any): SubscriptionTier {
    return SubscriptionTierToJSONTyped(json, false);
}

export function SubscriptionTierToJSONTyped(value?: SubscriptionTier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'color': value['color'],
        'stripeProductId': value['stripeProductId'],
        'isActive': value['isActive'],
        'xpMultiplier': value['xpMultiplier'],
        'tierLevel': value['tierLevel'],
        'level4Access': value['level4Access'],
        'image': value['image'],
        'pricing': ((value['pricing'] as Array<any>).map(SubscriptionPriceToJSON)),
        'upgradeFromPromos': value['upgradeFromPromos'],
        'entitlements': value['entitlements'] == null ? undefined : ((value['entitlements'] as Array<any>).map(TierEntitlementToJSON)),
        'monthlyRewardGrants': value['monthlyRewardGrants'] == null ? undefined : ((value['monthlyRewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'onSubscribeRewardGrants': value['onSubscribeRewardGrants'] == null ? undefined : ((value['onSubscribeRewardGrants'] as Array<any>).map(RewardGrantToJSON)),
        'monthlyRewardConfigIds': value['monthlyRewardConfigIds'],
        'onSubscribeRewardConfigIds': value['onSubscribeRewardConfigIds'],
        'upgradeFromRewards': value['upgradeFromRewards'],
        'isLegacyTier': value['isLegacyTier'],
    };
}

